import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { QueryParamValue } from "@faire/web/common/query-params/QueryParams";

// move product with specified token to front of array if possible

export const moveProductToFrontOfArray = <T extends ILeanProductTile>(
  products: (T | undefined)[],
  highlightToken: QueryParamValue,
  trackWhetherProductWasHighlighted?: (wasHighlighted: string) => void
): (T | undefined)[] => {
  if (
    !highlightToken ||
    typeof highlightToken !== "string" ||
    !products.some((item) => item !== undefined)
  ) {
    // no valid token or no products yet, product was not intended to be highlighted so don't track
    return products;
  }
  const highlightedProductIndex = products.findIndex(
    (item) => item?.product?.token === highlightToken
  );
  // product not in list, track failure
  if (highlightedProductIndex === -1) {
    trackWhetherProductWasHighlighted?.("false");
    return products;
  }

  // All highlight failures have escaped, track success
  trackWhetherProductWasHighlighted?.("true");

  // product is already in front
  if (highlightedProductIndex === 0) {
    return products;
  }
  const productsWithHighlights = products.slice();
  const [productToHighlight] = productsWithHighlights.splice(
    highlightedProductIndex,
    1
  );
  productsWithHighlights.unshift(productToHighlight);

  return productsWithHighlights;
};
